function normalizeMarker(value) {
  return String(value || '').trim().toLowerCase();
}

const HUMAN_REVIEW_TOUR_REASONS = new Set([
  'tour_requested',
  'tour_reschedule_requested',
  'tour_slot_declined',
  'tour_unavailable'
]);

function isTourPlannerMarker(value) {
  const marker = normalizeMarker(value);
  return (
    marker === 'dashboard_tour_planner' ||
    marker === 'tour_planner' ||
    marker === 'tour-planner' ||
    marker === 'tour_invite' ||
    marker.startsWith('tour_planner_') ||
    marker.startsWith('tour-planner-')
  );
}

function hasExplicitPlannerMarker(record) {
  const meta = record.meta || {};
  const markers = [
    record.source,
    meta.source,
    record.actionType,
    meta.actionType,
    record.workflow,
    meta.workflow,
    record.workflowType,
    record.workflowName,
    record.workflow?.name,
    record.workflow?.type,
    record.workflow?.id,
    meta.workflowType,
    meta.workflowName,
    meta.workflow?.name,
    meta.workflow?.type,
    meta.workflow?.id,
    record.schema,
    meta.schema,
    record.schemaType,
    record.schemaName,
    record.schemaVersion,
    record.schema?.name,
    record.schema?.type,
    record.schema?.id,
    record.schema?.version,
    meta.schemaType,
    meta.schemaName,
    meta.schemaVersion,
    meta.schema?.name,
    meta.schema?.type,
    meta.schema?.id,
    meta.schema?.version
  ];

  return markers.some(isTourPlannerMarker);
}

function hasCoreCampaignProvenance(record) {
  const meta = record.meta || {};
  return (
    normalizeMarker(record.source) === 'dashboard_new_campaign' ||
    normalizeMarker(meta.source) === 'dashboard_new_campaign' ||
    normalizeMarker(record.source) === 'dashboard_campaign_launch' ||
    normalizeMarker(meta.source) === 'dashboard_campaign_launch' ||
    normalizeMarker(record.actionType) === 'campaign_creation' ||
    normalizeMarker(meta.actionType) === 'campaign_creation' ||
    normalizeMarker(record.actionType) === 'campaign_launch' ||
    normalizeMarker(meta.actionType) === 'campaign_launch'
  );
}

function isCoreHumanReviewTourAction(record) {
  const meta = record.meta || {};
  const reason = normalizeMarker(meta.reason || record.reason);
  return record.kind === 'action_needed' && HUMAN_REVIEW_TOUR_REASONS.has(reason);
}

function isUnambiguousLegacyPlannerRecord(record) {
  const hasPlannerSubject = /^tour slot:/i.test(String(record.subject || '').trim());
  return Boolean(record.tourInvite || record.tourStatus || hasPlannerSubject);
}

export function isNextVersionSchedulingRecord(record = {}) {
  if (hasExplicitPlannerMarker(record)) return true;
  if (isCoreHumanReviewTourAction(record)) return false;
  if (hasCoreCampaignProvenance(record)) return false;
  return isUnambiguousLegacyPlannerRecord(record);
}
